module.exports = __webpack_public_path__ + "static/media/corkboard-texture.b6bd296a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/corkboard-texture.jpg
// module id = 489
// module chunks = 0